import React from 'react';
import { Dribbble, Linkedin, Mail, Phone } from 'lucide-react';

const MobileContactBar: React.FC = () => {
  return (
    <div className="flex md:hidden z-50 sticky bottom-0 right-0 w-full pb-4 bg-gradient-to-t from-white to-transparent">
      <div className="flex justify-between items-center w-full bg-white p-2 pr-4 shadow-xl rounded-full border border-gray-100">
        <img src="./profile-photo.webp" alt="Profile" className="w-8 h-8" />
        <div className="flex gap-6">
          <a
            href="https://dribbble.com/saifbinkhaki"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Dribbble className="text-[#D85888]" />
          </a>
          <a
            href="https://linkedin.com/in/saifbinkhaki"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Linkedin className="text-[#2D64BC]" />
          </a>
          <a
            href="mailto:saifbinkhaki@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Mail className="opacity-50" />
          </a>
          <a
            href="https://cal.com/saifbinkhaki/quick-chat-20-minutes"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Phone className="opacity-50" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileContactBar;
